// extracted by mini-css-extract-plugin
module.exports = {"nav":"FooterNav_nav__uztOz","nav__heading":"FooterNav_nav__heading__NGxAk"};